


// 1.right code 

// import React, { createContext, useEffect, useState } from 'react'
// import AxiosApi from '../api/AxiosApi';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';


// export const AuthenticationContext = createContext();

// export function AuthenticationProvider({ children }) {
//   const Navigate = useNavigate();
//   const [IsLogged, setIsLogged] = useState(false);
//   const [authLoading, setAuthLoading] = useState(true);
//   const [LoginLoading, setLoginLoading] = useState(false);
//   const [LoggedInUserInfo, setLoggedInUserInfo] = useState(null);

// // AuthenticationContext.js में बदलाव करें

// // 🔹 User Login Function
// // AuthenticationContext.js के अंदर userLogin फंक्शन

// function userLogin(LOGIN_NAME, PW, APP_KEY, isFromBusiness = false) {
//     // डायरेक्ट लॉगिन के लिए करंट टैब के sessionStorage में सेव करें
//     sessionStorage.setItem("LoginID", LOGIN_NAME);
//     sessionStorage.setItem("PW", PW);

//     setLoginLoading(true);
//     let headersList = {
//       Accept: "/",
//       "Content-Type": "application/x-www-form-urlencoded",
//     };
    
//     let bodyParams = new URLSearchParams();
//     bodyParams.append("LOGIN_NAME", LOGIN_NAME);
//     bodyParams.append("PW", PW);
//     bodyParams.append("APP_KEY", APP_KEY);

//     return AxiosApi.post("login/LoginWEB", bodyParams, headersList)
//       .then((res) => {
//         // डायरेक्ट लॉगिन के लिए sessionStorage सेट करें
//         sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(res?.data));
//         sessionStorage.setItem("LCODE", res?.data?.Loc_Code);

//         setLoggedInUserInfo(res?.data);
//         setIsLogged(true);
//         setLoginLoading(false);

//         // ✅ बिज़नेस डैशबोर्ड के लिए: सब कुछ एक साथ पैक करके localStorage में डालें 
//         // ताकि नया टैब इसे आसानी से निकाल सके
//         if (isFromBusiness) {
//           const transferPacket = {
//             userInfo: res?.data,
//             loginId: LOGIN_NAME,
//             pw: PW,
//             lcode: res?.data?.Loc_Code
//           };
//           localStorage.setItem("transfer_tmp_user", JSON.stringify(transferPacket));
//         } else {
//           Navigate("/userDashboard");
//         }
        
//         return res?.data;
//       })
//       .catch((er) => {
//         alert("Invalid Credentials!");
//         setLoginLoading(false);
//         throw er;
//       });
// }

// // 🔹 User Logout Function



// // 2.

// const logOut = () => {
//     // 1. यूजर से जुड़ी सभी sessionStorage कीज़ को साफ करें
//     sessionStorage.removeItem("LoggedInUserInfo");
//     sessionStorage.removeItem("LoginID");
//     sessionStorage.removeItem("PW");
//     sessionStorage.removeItem("LCODE");
    
//     // 2. बिजनेस के रास्ते से आए 'pass' मार्क को हटाएं
//     localStorage.removeItem("pass");
//     localStorage.removeItem("transfer_tmp_user");

//     // 3. इस टैब की रिएक्ट स्टेट्स को रीसेट करें
//     if (typeof setLoggedInUserInfo === 'function') setLoggedInUserInfo(null);
//     if (typeof setIsLogged === 'function') setIsLogged(false);

//     // ✅ 4. बेस्ट सॉल्यूशन: पूरे ऐप की मेमोरी को फ्लश करके लॉगिन पेज पर भेजें
//     // इससे यूआरएल के साथ-साथ स्क्रीन पर लॉगिन पेज भी तुरंत आ जाएगा
//     window.location.replace("/login");
// };

// // 🔹 Check Auth on Mount
// useEffect(() => {
//     // sessionStorage से डेटा रीड करें
//     const data = sessionStorage.getItem("LoggedInUserInfo");
//     const userData = data ? JSON.parse(data) : null;
    
//     if (userData) {
//       setIsLogged(true);
//       setLoggedInUserInfo(userData);
//     } else {
//       setIsLogged(false);
//       setLoggedInUserInfo(null);
//     }
//     setAuthLoading(false);
// }, []);

//   return (
//     <AuthenticationContext.Provider
//       value={{
//         IsLogged,
//         setLoggedInUserInfo,
//         LoggedInUserInfo,
//         LoginLoading,
//         userLogin,
//         logOut,
//         authLoading,
//       }}
//     >
//       {children}
//     </AuthenticationContext.Provider>
//   );
// }

// 2.latest code 14-july

// import React, { createContext, useEffect, useState } from 'react'
// import AxiosApi from '../api/AxiosApi';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import { useNavigate } from 'react-router-dom';


// export const AuthenticationContext = createContext();

// // AuthenticationContext.js के अंदर getInitialUser फंक्शन को ऐसे अपडेट करें:

// const getInitialUser = () => {
//   if (typeof window === 'undefined') return null;

//   // 1. पहले हमेशा की तरह sessionStorage चेक करें
//   const sessionData = sessionStorage.getItem("LoggedInUserInfo");
//   if (sessionData) {
//     try { return JSON.parse(sessionData); } catch (e) { console.error(e); }
//   }

//   // 2. 🟢 नया तरीका: अब हम नॉर्मल सर्च और हैश (#) दोनों से टोकन चेक करेंगे
//   const currentHref = window.location.href;
//   let token = null;

//   if (currentHref.includes('token=')) {
//     // यूआरएल में से टोकन निकालने का सबसे सुरक्षित तरीका
//     const urlParts = currentHref.split('token=');
//     if (urlParts.length > 1) {
//       token = urlParts[1].split('&')[0]; // अगर आगे और भी पैरम्स हों तो सिर्फ टोकन लें
//     }
//   }

//   if (token) {
//     try {
//       // टोकन को डिकोड करें
//       const decodedData = JSON.parse(decodeURIComponent(atob(token)));
      
//       // तुरंत नए टैब के sessionStorage में डेटा भरें
//       sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(decodedData.userInfo));
//       sessionStorage.setItem("LoginID", decodedData.loginId || "");
//       sessionStorage.setItem("PW", decodedData.pw || "");
//       sessionStorage.setItem("LCODE", decodedData.lcode || "");
      
//       // यूआरएल से टोकन साफ करें ताकि स्क्रीन साफ दिखे
//       const cleanUrl = window.location.origin + window.location.pathname + window.location.hash.split('?')[0];
//       window.history.replaceState({}, document.title, cleanUrl);

//       return decodedData.userInfo;
//     } catch (e) {
//       console.error("Error decoding token from URL", e);
//     }
//   }
//   return null;
// };

// export function AuthenticationProvider({ children }) {
//   const Navigate = useNavigate();
  
//   const [LoggedInUserInfo, setLoggedInUserInfo] = useState(getInitialUser);
//   const [IsLogged, setIsLogged] = useState(() => !!getInitialUser());
//   const [authLoading, setAuthLoading] = useState(false);
//   const [LoginLoading, setLoginLoading] = useState(false);

//   // 🔹 यह फंक्शन अब सिर्फ डायरेक्ट यूजर लॉगिन के काम आएगा
//   function userLogin(LOGIN_NAME, PW, APP_KEY) {
//     sessionStorage.setItem("LoginID", LOGIN_NAME);
//     sessionStorage.setItem("PW", PW);

//     setLoginLoading(true);
//     let headersList = { Accept: "/", "Content-Type": "application/x-www-form-urlencoded" };
    
//     let bodyParams = new URLSearchParams();
//     bodyParams.append("LOGIN_NAME", LOGIN_NAME);
//     bodyParams.append("PW", PW);
//     bodyParams.append("APP_KEY", APP_KEY);

//     return AxiosApi.post("login/LoginWEB", bodyParams, headersList)
//       .then((res) => {
//         sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(res?.data));
//         sessionStorage.setItem("LCODE", res?.data?.Loc_Code);

//         setLoggedInUserInfo(res?.data);
//         setIsLogged(true);
//         setLoginLoading(false);

//         Navigate("/userDashboard");
//         return res?.data;
//       })
//       .catch((er) => {
//         alert("Invalid Credentials!");
//         setLoginLoading(false);
//         throw er;
//       });
//   }

//   const logOut = () => {
//     sessionStorage.clear();
//     localStorage.removeItem("pass");
//     setLoggedInUserInfo(null);
//     setIsLogged(false);
//     window.location.replace("/login");
//   };

//   useEffect(() => {
//     setAuthLoading(false);
//   }, []);

//   return (
//     <AuthenticationContext.Provider
//       value={{ IsLogged, setIsLogged, setLoggedInUserInfo, LoggedInUserInfo, LoginLoading, userLogin, logOut, authLoading }}
//     >
//       {children}
//     </AuthenticationContext.Provider>
//   );
// }

// 3.

import React, { createContext, useEffect, useState } from 'react';
import AxiosApi from '../api/AxiosApi';
import { useNavigate } from 'react-router-dom';

export const AuthenticationContext = createContext();

// शुरुआती रेंडर पर सिर्फ डेटा प्राप्त करने के लिए
const getInitialUser = () => {
  if (typeof window === 'undefined') return null;

  // 1. पहले से मौजूद sessionStorage चेक करें
  const sessionData = sessionStorage.getItem("LoggedInUserInfo");
  if (sessionData) {
    try { 
      return JSON.parse(sessionData); 
    } catch (e) { 
      console.error("Error parsing session data", e); 
    }
  }

  // 2. यूआरएल (नॉर्मल या हैश दोनों) से टोकन सुरक्षित रूप से निकालें
  const currentHref = window.location.href;
  let token = null;

  if (currentHref.includes('token=')) {
    try {
      // हैश के बाद वाले क्वेरी स्ट्रिंग को पार्स करने के लिए सुरक्षित तरीका
      const queryString = currentHref.includes('?') ? currentHref.split('?')[1] : '';
      const urlParams = new URLSearchParams(queryString);
      token = urlParams.get('token');
    } catch (err) {
      // फॉलबैक तरीका अगर URLSearchParams काम न करे
      const urlParts = currentHref.split('token=');
      if (urlParts.length > 1) {
        token = urlParts[1].split('&')[0];
      }
    }
  }

  // 3. टोकन डिकोड करके स्टोर करें
  if (token) {
    try {
      const decodedData = JSON.parse(decodeURIComponent(atob(token)));
      
      // तुरंत sessionStorage में डेटा भरें ताकि राउटर इसे तुरंत एक्सेस कर सके
      sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(decodedData.userInfo));
      sessionStorage.setItem("LoginID", decodedData.loginId || "");
      sessionStorage.setItem("PW", decodedData.pw || "");
      sessionStorage.setItem("LCODE", decodedData.lcode || "");

      // अगर यह बिज़नेस पैनल से लॉगिन होकर आया है, तो इसे इसी टैब के sessionStorage में स्टोर करें
      if (decodedData.isImpersonated) {
        sessionStorage.setItem("user_is_impersonated", "true");
      }

      return decodedData.userInfo;
    } catch (e) {
      console.error("Error decoding token from URL", e);
    }
  }
  return null;
};

export function AuthenticationProvider({ children }) {
  const Navigate = useNavigate();
  
  const [LoggedInUserInfo, setLoggedInUserInfo] = useState(getInitialUser);
  const [IsLogged, setIsLogged] = useState(() => !!getInitialUser());
  const [authLoading, setAuthLoading] = useState(false);
  const [LoginLoading, setLoginLoading] = useState(false);

  // 🟢 लाइव सर्वर फिक्स: हैश राउटर के पाथ को बिगाड़े बिना यूआरएल से केवल 'token' हटाना
  useEffect(() => {
    const currentHref = window.location.href;
    
    if (currentHref.includes('token=')) {
      try {
        const urlObj = new URL(currentHref.replace('/#/', '/')); // अस्थाई रूप से हैश हटाकर URL ऑब्जेक्ट पार्स करें
        const params = new URLSearchParams(urlObj.search);
        
        // केवल token पैरामीटर डिलीट करें
        params.delete('token');
        
        // नया क्वेरी स्ट्रिंग बनाएँ
        const newQuery = params.toString();
        
        // हैश राउटर का सही फॉर्मेट वापस तैयार करें
        const hashPath = window.location.hash.split('?')[0]; // जैसे: #/userDashboard
        const cleanUrl = newQuery 
          ? `${window.location.origin}/${hashPath}?${newQuery}` 
          : `${window.location.origin}/${hashPath}`;

        // ब्राउज़र की हिस्ट्री और स्टोरेज को बिना नुकसान पहुँचाए URL क्लीन करें
        window.history.replaceState(null, '', cleanUrl);
      } catch (err) {
        console.error("Failed to clean token from URL", err);
      }

      // सुरक्षित तरीके से रिएक्ट राउटर के माध्यम से डैशबोर्ड पर भेजें
      Navigate("/userDashboard", { replace: true });
    }
    setAuthLoading(false);
  }, [Navigate]);

  // यह फंक्शन सिर्फ डायरेक्ट यूजर लॉगिन के काम आएगा
  function userLogin(LOGIN_NAME, PW, APP_KEY) {
    sessionStorage.setItem("LoginID", LOGIN_NAME);
    sessionStorage.setItem("PW", PW);

    setLoginLoading(true);
    let headersList = { Accept: "/", "Content-Type": "application/x-www-form-urlencoded" };
    
    let bodyParams = new URLSearchParams();
    bodyParams.append("LOGIN_NAME", LOGIN_NAME);
    bodyParams.append("PW", PW);
    bodyParams.append("APP_KEY", APP_KEY);

    return AxiosApi.post("login/LoginWEB", bodyParams, headersList)
      .then((res) => {
        sessionStorage.setItem("LoggedInUserInfo", JSON.stringify(res?.data));
        sessionStorage.setItem("LCODE", res?.data?.Loc_Code);

        setLoggedInUserInfo(res?.data);
        setIsLogged(true);
        setLoginLoading(false);

        Navigate("/userDashboard");
        return res?.data;
      })
      .catch((er) => {
        alert("Invalid Credentials!");
        setLoginLoading(false);
        throw er;
      });
  }

  // बिना विंडो रीलोड या localStorage को छेड़े सुरक्षित लॉगआउट (सिर्फ इस टैब के लिए)
  const logOut = () => {
    sessionStorage.clear(); // सिर्फ इसी टैब का यूजर डेटा साफ़ होगा
    setLoggedInUserInfo(null);
    setIsLogged(false);
    Navigate("/login", { replace: true }); 
  };

  return (
    <AuthenticationContext.Provider
      value={{ IsLogged, setIsLogged, setLoggedInUserInfo, LoggedInUserInfo, LoginLoading, userLogin, logOut, authLoading }}
    >
      {children}
    </AuthenticationContext.Provider> 
  );  
}